import { z } from "zod";
/** A row of the send log, as `GET /emails` returns it (SPEC §5, §7). */
export const sentEmailSchema = z.object({
    sentAt: z.string(),
    /**
     * Shared by every message from one worker run. One alert going to five
     * recipients is five SES sends and five SENT rows, but one event — without
     * this the history reads as five identical alerts.
     *
     * Optional: rows written before this existed do not carry it.
     */
    batchId: z.string().optional(),
    subject: z.string(),
    recipients: z.array(z.string()),
    trigger: z.string(),
    siteId: z.string(),
    sesMessageId: z.string(),
    bodySnippet: z.string(),
});
export const emailsResponseSchema = z.object({
    items: z.array(sentEmailSchema),
    nextCursor: z.string().nullable(),
});
export const EMAILS_MIN_DAYS = 1;
export const EMAILS_MAX_DAYS = 14;
export const EMAILS_DEFAULT_DAYS = 7;
export const EMAILS_PAGE_SIZE = 50;
/** `days` clamps to 1–14 and defaults to 7 (SPEC §7). */
export function clampDays(raw) {
    if (raw == null || raw === "")
        return EMAILS_DEFAULT_DAYS;
    const parsed = typeof raw === "number" ? raw : Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed))
        return EMAILS_DEFAULT_DAYS;
    return Math.min(EMAILS_MAX_DAYS, Math.max(EMAILS_MIN_DAYS, Math.trunc(parsed)));
}
//# sourceMappingURL=emails.js.map